import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { PrimaryButton } from '@huggg/react-components';
import { useAnalytics } from 'hooks';
import { getBasePathname } from 'utilities/huggg';
import dictionary from 'config/dictionary';
import styles from '../more-details.module.scss';

const RedeemButton = props => {
  const { huggg, onClick: passedClickHandler = () => {}, disabled } = props;
  const analytics = useAnalytics();

  return (
    <Link
      onClick={() => {
        analytics.buttonClickHugggActionsRedeem();
        passedClickHandler();
      }}
      disabled={disabled}
      to={`${getBasePathname(huggg)}/redeem`}
      style={{ width: '320px', textDecoration: 'none' }}
    >
      <PrimaryButton
        label={dictionary.nextButton}
        disabled={disabled}
        className={styles.CTAButton}
      />
    </Link>
  );
};

RedeemButton.propTypes = {
  huggg: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default RedeemButton;
